<template>
  <router-view/>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
}
@media print {
  .no-print, .no-print * {
    display: none !important;
  }
  .main-title {
    display: none !important;
  }
  .search-bar {
    display: none !important;
  }
  .el-table__fixed-right {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue